// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#g-recaptcha[data-v-26671972] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
